export enum EFGCrateIconType {
  CIT_DeathIcon,
}
